"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Pressable = _interopRequireDefault(require("react-native-web/dist/cjs/exports/Pressable"));
var _View = _interopRequireDefault(require("react-native-web/dist/cjs/exports/View"));
var _StyleSheet = _interopRequireDefault(require("react-native-web/dist/cjs/exports/StyleSheet"));
var _utils = require("../utils");
var _ThemeProvider = require("../ThemeProvider");
var _Typography = _interopRequireDefault(require("../Typography"));
var _Spacer = _interopRequireDefault(require("../Spacer"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const selectTypographyStyles = (_ref, isSelected) => {
  let {
    fontWeight,
    color,
    lineHeight,
    fontName,
    activeColor
  } = _ref;
  return {
    fontWeight,
    color: isSelected ? activeColor : color,
    lineHeight,
    fontName
  };
};
const selectIconContainerStyles = _ref2 => {
  let {
    paddingTop,
    paddingBottom
  } = _ref2;
  return {
    paddingTop,
    paddingBottom,
    alignItems: 'center'
  };
};
const selectIconStyles = (_ref3, isSelected) => {
  let {
    iconSize,
    iconColor,
    activeColor
  } = _ref3;
  return {
    size: iconSize,
    color: isSelected ? activeColor : iconColor
  };
};
const selectContainerStyles = _ref4 => {
  let {
    borderRadius,
    backgroundColor
  } = _ref4;
  return {
    borderRadius,
    backgroundColor,
    alignSelf: 'center',
    alignItems: 'center'
  };
};
const TabBarItem = /*#__PURE__*/_react.default.forwardRef((_ref5, ref) => {
  let {
    href,
    variant,
    tokens,
    label,
    isSelected,
    id,
    onPress,
    icon: IconComponent,
    iconActive: IconActiveComponent,
    accessibilityRole = 'tab'
  } = _ref5;
  const getTokens = (0, _ThemeProvider.useThemeTokensCallback)('TabBarItem', tokens, variant);
  const getPressableStyle = _ref6 => {
    let {
      pressed,
      focused,
      hovered
    } = _ref6;
    const resolvedTokens = (0, _utils.resolvePressableTokens)(getTokens, {
      pressed,
      focused,
      hovered
    }, {
      isSelected
    });
    return {
      ...resolvedTokens,
      outline: 'none' // removes the default browser :focus outline
    };
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Pressable.default, {
    ref: ref,
    href: href,
    nativeID: id,
    onPress: onPress,
    style: _ref7 => {
      let {
        pressed,
        focused,
        hovered
      } = _ref7;
      return [styles.flexContainer, getPressableStyle({
        pressed,
        focused,
        hovered
      })];
    },
    accessibilityRole: accessibilityRole,
    testID: id,
    children: pressableState => {
      const resolvedTokens = getPressableStyle(pressableState);
      return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_View.default, {
        style: selectContainerStyles(resolvedTokens),
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_View.default, {
          style: [selectIconContainerStyles(resolvedTokens), styles.iconContainer],
          children: isSelected ? IconActiveComponent && /*#__PURE__*/(0, _jsxRuntime.jsx)(IconActiveComponent, {
            ...selectIconStyles(resolvedTokens, isSelected)
          }) : IconComponent && /*#__PURE__*/(0, _jsxRuntime.jsx)(IconComponent, {
            ...selectIconStyles(resolvedTokens)
          })
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Spacer.default, {
          space: 1
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Typography.default, {
          variant: {
            size: 'micro'
          },
          tokens: selectTypographyStyles(resolvedTokens, isSelected),
          align: "center",
          children: label
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Spacer.default, {
          space: 1
        })]
      });
    }
  });
});
TabBarItem.displayName = 'TabBarItem';
TabBarItem.propTypes = {
  /** The icon to be displayed when the item is not selected. */
  icon: _propTypes.default.elementType,
  /** The icon to be displayed when the item is selected. */
  iconActive: _propTypes.default.elementType,
  /** Tokens for theming and styling the TabBarItem. */
  tokens: (0, _utils.getTokensPropType)('TabBarItem'),
  /** Variant of the TabBarItem for styling purposes. */
  variant: _utils.variantProp.propType,
  /** Callback function to handle press events. */
  onPress: _propTypes.default.func,
  /** URL to navigate to when the item is pressed. */
  href: _propTypes.default.string,
  /** Indicates whether the item is selected. */
  isSelected: _propTypes.default.bool,
  /** Unique identifier for the item. */
  id: _propTypes.default.string,
  /** Label text for the item. */
  label: _propTypes.default.string.isRequired,
  /** Accessibility role for the item. */
  accessibilityRole: _propTypes.default.string
};
const styles = _StyleSheet.default.create({
  flexContainer: {
    flex: 1,
    alignItems: 'center'
  },
  iconContainer: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    minWidth: 44,
    minHeight: 40,
    aspectRatio: 1.1
  }
});
var _default = exports.default = TabBarItem;